import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import styled, { css } from 'styled-components';

import { CloseWorkflowModalIcon } from '../icons/svgs';
import ScrollbarStyle from '../styles/ConstScrollbarStyle';
import { MobileScreen } from '../styles/ConstantMediaQuery';
import { getZIndexByLayerName, LayerNames } from '../../constants/layers.constants';
import TEST_ID from '../../constants/testId.constants';
import { APPCUES_ID } from './full-screen-modal.constants';

interface FullScreenModalProps extends React.HTMLAttributes<HTMLDivElement> {
    iconColor?: string;
    isOpen: boolean;
    isNewModal?: boolean;
    onClose?: Function;
    styles?: Object;
    dataTestId?: string;
}

const FullScreenModal = ({
    children,
    iconColor,
    isOpen,
    isNewModal,
    onClose,
    styles = {},
    dataTestId,
}: FullScreenModalProps) => (
    <Dialog
        aria-describedby="alert-dialog-description"
        aria-labelledby="alert-dialog-title"
        BackdropProps={{ style: { backgroundColor: '#ffffff' } }}
        fullScreen
        fullWidth
        maxWidth="md"
        open={isOpen}
        data-testid={dataTestId}
    >
        {
            onClose && (
                <CloseIconWrapper
                    onClick={onClose}
                    data-testid={TEST_ID.FULL_SCREEN_MODAL_CLOSE_ICON}
                    data-appcues-id={APPCUES_ID.FULL_SCREEN_MODAL_CLOSE_ICON}
                >
                    <CloseWorkflowModalIcon
                        backgroundColor={iconColor}
                        height="35px"
                        width="35px"
                    />
                </CloseIconWrapper>
            )
        }
        <ScrollableContentWrapper>
            <StyledDialogContent isNewModal={isNewModal} styles={styles}>
                {children}
            </StyledDialogContent>
        </ScrollableContentWrapper>
    </Dialog>
);

const StyledDialogContent = styled.div`
    height: fit-content;
    padding-bottom: 15vh;
    ${ScrollbarStyle};
    
    ${({ isNewModal }) => !isNewModal && css`
        overflow: hidden;
        position: relative;
    `}

    ${({ isNewModal }) => !isNewModal && css`
        padding-top: 5vh;
        margin: 0 auto;
        width: 550px;

        @media ${MobileScreen} {
            overflow: hidden;
            padding: 5vh 4vw 15vh 4vw;
            width: 100vw;
        }
    `}
    ${({ styles }) => styles};
`;

const ScrollableContentWrapper = styled.div`
    ${ScrollbarStyle};
`;

export const CloseIconWrapper = styled.span`
    cursor: pointer;
    position: absolute;
    right: 50px;
    top: 50px;
    z-index: ${getZIndexByLayerName(LayerNames.CURR_VALUE_2)};

    &:hover {
        opacity: 0.7;
        transition: opacity 0.3s ease;
    }

    @media ${MobileScreen} {
        right: 10;
        top: 10;
    }
`;

export default FullScreenModal;
